import {
  formatQuantityWithUnit,
  getDefaultConversionUnit,
  toConvertedQuantity,
} from '@atom/components/inventoryDetail/costTab/costTabUtilities';
import { ConversionUnit } from '@atom/types/schema';

import classes from './inventoryPortal.module.css';

type InventoryQuantityOnHandCellProps = {
  quantityOnHand?: number;
  unit?: string;
  conversionUnits?: ConversionUnit[] | null;
};

const InventoryQuantityOnHandCell = ({
  quantityOnHand,
  unit,
  conversionUnits,
}: InventoryQuantityOnHandCellProps) => {
  const defaultConversionUnit = getDefaultConversionUnit(conversionUnits);

  return (
    <>
      <div className={classes.quantityOnHand}>
        {formatQuantityWithUnit(quantityOnHand, unit)}
      </div>
      {defaultConversionUnit && (
        <div className={classes.quantityOnHandConversion}>
          {formatQuantityWithUnit(
            toConvertedQuantity(quantityOnHand, defaultConversionUnit),
            defaultConversionUnit.unit,
          )}
        </div>
      )}
    </>
  );
};

export default InventoryQuantityOnHandCell;
